import { PaginationOptions } from 'swiper/types';

export const PAGINATION: PaginationOptions = {
  clickable: true,
  currentClass: 'swiperPagination',
  bulletClass: 'bulletClass',
  bulletActiveClass: 'bulletActiveClass',
};
